import { Grid } from "@mui/material"

import { LinearLoading } from 'common'

export const InfoVehicleReception = ({ useFetchInit }) => {
    const { FetchData, Forms } = useFetchInit
    const { fetchInfoVehicleReception } = FetchData
    const { loadingFetchInfoVehicleReception } = fetchInfoVehicleReception
    const { FormScreen } = Forms
    const { formState } = FormScreen
    return (
        <>
            {(loadingFetchInfoVehicleReception) && (<LinearLoading />)}
            {(formState.infoReception.length > 0) && (
                <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }} sx={{ marginBottom: 2, marginTop: 2 }}>
                    <Grid item xs={12} sm={12} md={6} lg={6}>
                        <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
                            <span style={{ fontSize: '1.1rem' }}>
                                <strong>IDENTIFICADOR:</strong> {formState.infoReception[0]?.identificador || '' }
                            </span>
                            <span style={{ fontSize: '1.1rem' }}>
                                <strong>AUTORIDAD:</strong> {formState.infoReception[0]?.nombre_autoridad || '' }
                            </span>
                            <span style={{ fontSize: '1.1rem' }}>
                                <strong>FECHA INGRESO:</strong> {formState.infoReception[0]?.info_fecha_ingreso || '' }
                            </span>
                            <span style={{ fontSize: '1.1rem' }}>
                                <strong>TARIFA APLICADA:</strong> {formState.infoReception[0]?.tarifa_aplicada || '' } - Q {formState.infoReception[0]?.tarifa_monto || '' }
                            </span>
                            <span style={{ fontSize: '1.1rem' }}>
                                <strong>DIAS TRANSCURRIDOS:</strong> {formState.infoReception[0]?.dias_transcurridos || '' }
                            </span>
                            <span style={{ fontSize: '1.1rem' }}>
                                <strong>TOTAL POR DIAS:</strong> Q {formState.infoReception[0]?.total_por_dias || '' }
                            </span>
                        </div>
                    </Grid>
                    <Grid item xs={12} sm={12} md={6} lg={6}>
                        <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
                            <span style={{ fontSize: '1.1rem' }}>
                                <strong>GASTOS EXTRAS:</strong> Q {formState.infoReception[0]?.other_expense_total || '' }
                            </span>
                            <span style={{ fontSize: '1.1rem' }}>
                                <strong>TOTAL DESCUENTOS:</strong> Q {formState.infoReception[0]?.info_descuento || '' }
                            </span>
                            <span style={{ fontSize: '1.1rem' }}>
                                <strong>TOTAL A PAGAR:</strong> Q {formState.infoReception[0]?.total_pagar || '' }
                            </span>
                            <span style={{ fontSize: '1.1rem' }}>
                                <strong>TOTAL RECIBIDO:</strong> Q {formState.infoReception[0]?.total_recibido || '' }
                            </span>
                            <span style={{ fontSize: '1.1rem' }}>
                                <strong>SALDO:</strong> Q {formState.infoReception[0]?.saldo_total || '' }
                            </span>
                        </div>
                    </Grid>
                </Grid>
            )}
        </>
    )
}
